import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PRODUCT_TRANSACTION_TYPE } from '../../../utils/constants';

export function ProductTransactionTypeForm({
  errors,
  productTransactionType,
  Controller,
  control,
}) {
  return (
    <div className="flex flex-row flex-wrap">
      <div className="w-full px-1 py-2">
        <Controller
          name={'name'}
          control={control}
          defaultValue={
            productTransactionType ? productTransactionType.name : ''
          }
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ชื่อประเภทการดำเนินการ"
              fullWidth
              size={'small'}
              helperText={errors.name && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-2">
        <Controller
          name={'direction'}
          control={control}
          defaultValue={
            productTransactionType ? productTransactionType?.direction : ''
          }
          rules={{ required: true }}
          render={({ field }) => (
            <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
              <InputLabel id="type" size={'small'}>
                ประเภทการดำเนินการ
              </InputLabel>
              <Select
                {...field}
                label="ประเภทการดำเนินการ"
                size={'small'}
                fullWidth
              >
                 {_.size(PRODUCT_TRANSACTION_TYPE) ? (
                  _.map(PRODUCT_TRANSACTION_TYPE, (transactionType) => (
                    <MenuItem key={transactionType.name} value={transactionType.direction}>
                      {transactionType.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>
                    <MenuItem disabled value="">
                      <em>ไม่มีข้อมูล</em>
                    </MenuItem>
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          )}
        />
      </div>
    </div>
  );
}

ProductTransactionTypeForm.propTypes = {
  errors: PropTypes.shape({
    name: PropTypes.object,
    direction: PropTypes.object,
  }),
  productTransactionType: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
};

ProductTransactionTypeForm.defaultProps = {
  productTransactionType: null,
};

export default ProductTransactionTypeForm;
